import Helper from "./Helper";
import Swiper from "../lib/swiper";
import swiper from "../lib/swiper";

class Slider {
  constructor(config = {}) {
    const { } = config;

    this.swiperInstance = null;
    this.homeSwiperInstance = null;
    this.initSwiper(config);
  }

  initSwiper(config) {
    this.swiperInstance = new Swiper('.ns-quote-slider .swiper-container', {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      autoplay: {
        delay: 10000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    this.homeSwiperInstance = new Swiper('.ns-frontpage-slider .swiper-container', {
      // Default parameters
      touchEventsTarget: 'container',

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      centeredSlides: true,
      initialSlide: 0,
      keyboard: {
        enabled: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        767: {
          initialSlide: 1,
          slidesPerView: 3,
          spaceBetween: 20
        }
      }



  });
}
}

export default Slider;
